var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, isSameEntityPath } from '@shapeable/utils';
var cls = classNames('menu-items-list');
import { breakpoints, theme } from '@shapeable/theme';
import { MenuItemLink } from './menu-item-link';
import { useActiveEntity } from '../hooks/use-active-entity';
import { useMenu } from '../hooks/use-menu';
import { ChevronRightIconGlyph } from '@shapeable/icons';
export var MenuItemsListDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    font-weight: 400;\n  "], ["\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    font-weight: 400;\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 0 !important;\n    padding: ", " 0 ", ";\n    ", ";\n  "], ["\n    margin: 0 !important;\n    padding: ", " 0 ", ";\n    ", ";\n  "])), theme.UNIT(3), theme.UNIT(3, 2), theme.H_DOT_BG_END('line-mid', 1.5, 4))
});
var ItemLinkStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    font-size: ", ";\n  "], ["\n    display: flex;\n    font-size: ", ";\n  "])), theme.FONT_SIZE(16))
});
var IconStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 16px !important;\n    height: 16px !important;\n    ", ";\n    svg {\n      width: 16px !important;\n      height: 16px !important;\n    }\n  "], ["\n    width: 16px !important;\n    height: 16px !important;\n    ", ";\n    svg {\n      width: 16px !important;\n      height: 16px !important;\n    }\n  "])), theme.FILL('secondary'))
});
// -------- Components -------->
var My = {
  Container: styled.ul(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled.li.attrs(cls.attr('item'))(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  ItemLink: styled(MenuItemLink)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ItemLinkStyles),
  Icon: styled(ChevronRightIconGlyph)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var MenuItemsList = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var currentEntity = useActiveEntity();
  var hideOnClick = useMenu().hideOnClick;
  var linkStyle = {
    justifyContent: 'space-between',
    display: 'flex',
    flexGrow: 1
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, entity && entity.items.map(function (item) {
    return React.createElement(My.Item, {
      className: cls.sub("item"),
      key: item.path
    }, React.createElement(My.ItemLink, {
      icon: React.createElement(My.Icon, null),
      style: linkStyle,
      onClick: hideOnClick,
      className: cls.sub("item-link"),
      isActive: isSameEntityPath(currentEntity, item),
      entity: item
    }));
  }));
};
MenuItemsList.defaultProps = MenuItemsListDefaultProps;
MenuItemsList.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;